import React, { useMemo } from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import ReactTable from '../../../../../components/ReactTable';

const ArchivedModal = ({ data, tableColumns, ...props }) => {
  const columns = useMemo(() => tableColumns, [tableColumns]);

  return (
    <Box py={2} {...props}>
      <ReactTable tableColumns={columns} tableData={data} />
      {!data.length && (
        <Box justifyContent="center" py={4} textAlign="center">
          <Text>None</Text>
        </Box>
      )}
    </Box>
  );
};

ArchivedModal.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  tableColumns: PropTypes.arrayOf(PropTypes.shape({}))
};

export default ArchivedModal;
